import { render, staticRenderFns } from "./AwesomeTable.vue?vue&type=template&id=4e51cec6&"
import script from "./AwesomeTable.vue?vue&type=script&lang=js&"
export * from "./AwesomeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports